export default "Ja, ich habe die nötigen Dokumente und Unterlagen";



// WEBPACK FOOTER //
// ./src/i18n/de/home/steps/0/approve.js